import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo, useEffect } from 'react';
import { isElevationThemeKeys } from '../../../themes/theme-keys/elevations.esm.js';
import { noop } from '../../../utils/function.esm.js';
import { getBackground, getBorder, getColor, omitBorder, omitColor, omitBackground } from '../../../utils/props-utils.esm.js';
import { BoxPrivate } from '../../_primitives/box/box.esm.js';
import { EMPTY_OBJECT } from '../../../utils/object.esm.js';

var _excluded = ["variant", "styledBorder", "elevation", "square", "__css", "sx"],
  _excluded2 = ["__themeKey", "variant", "className", "onMounted"],
  _excluded3 = ["border"];
var PanePrivate = /*#__PURE__*/React.forwardRef(function PanePrivate(props, ref) {
  var _useMemo = useMemo(function () {
      var variant = props.variant,
        styledBorder = props.styledBorder,
        elevation = props.elevation,
        square = props.square,
        _props$__css = props.__css,
        __cssProps = _props$__css === void 0 ? EMPTY_OBJECT : _props$__css,
        sx = props.sx,
        rest = _objectWithoutProperties(props, _excluded);
      var combineBackground = _objectSpread2(_objectSpread2(_objectSpread2({}, getBackground(rest)), getBackground(__cssProps)), getBackground(sx !== null && sx !== void 0 ? sx : EMPTY_OBJECT));
      var combineBorder = _objectSpread2(_objectSpread2(_objectSpread2({}, getBorder(rest)), getBorder(__cssProps)), getBorder(sx !== null && sx !== void 0 ? sx : EMPTY_OBJECT));
      var combineColor = _objectSpread2(_objectSpread2(_objectSpread2({}, getColor(rest)), getColor(__cssProps)), getColor(sx !== null && sx !== void 0 ? sx : EMPTY_OBJECT));
      return {
        restProps: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          variant: variant,
          elevation: elevation
        }, combineColor), combineBackground), combineBorder), omitBorder(omitColor(omitBackground(rest)))),
        restCss: _objectSpread2(_objectSpread2(_objectSpread2({
          outline: 'none'
        }, !variant && styledBorder !== 'shadow' && typeof styledBorder !== 'boolean' ? {
          border: styledBorder
        } : styledBorder === 'shadow' ? {
          boxShadow: 'defaultRise'
        } : styledBorder === true ? {
          border: 'neutral.medium'
        } : EMPTY_OBJECT), !variant && isElevationThemeKeys(elevation) ? {
          elevation: elevation,
          boxShadow: 'defaultRise'
        } : EMPTY_OBJECT), {}, {
          bg: 'white',
          borderRadius: square ? 0 : 'md'
        }, omitBorder(omitColor(omitBackground(__cssProps)))),
        restSx: _objectSpread2(_objectSpread2({}, omitBorder(omitColor(omitBackground(sx !== null && sx !== void 0 ? sx : EMPTY_OBJECT)))), typeof styledBorder === 'boolean' && styledBorder === false ? {
          border: 'unset'
        } : EMPTY_OBJECT)
      };
    }, [props]),
    restProps = _useMemo.restProps,
    restCss = _useMemo.restCss,
    restSx = _useMemo.restSx;
  var _restProps$__themeKey = restProps.__themeKey,
    __themeKey = _restProps$__themeKey === void 0 ? 'layout' : _restProps$__themeKey,
    _restProps$variant = restProps.variant,
    variant = _restProps$variant === void 0 ? 'pane' : _restProps$variant,
    className = restProps.className,
    _restProps$onMounted = restProps.onMounted,
    onMounted = _restProps$onMounted === void 0 ? noop : _restProps$onMounted,
    rest = _objectWithoutProperties(restProps, _excluded2);
  useEffect(function () {
    var timer = setTimeout(function () {
      return onMounted();
    }, 200);
    return function () {
      return clearTimeout(timer);
    };
  }, [onMounted]);
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    ref: ref,
    __themeKey: __themeKey,
    variant: variant,
    relative: true,
    className: classNames({
      'csg-tui-pane': true
    }, className),
    __css: restCss,
    sx: restSx
  }, rest));
});
var Pane = /*#__PURE__*/React.forwardRef(function Pane(props, ref) {
  var border = props.border,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(PanePrivate, _extends({
    ref: ref,
    styledBorder: border
  }, rest));
});

export default Pane;
export { PanePrivate };
//# sourceMappingURL=pane.esm.js.map
